const push = (data: any) => {
    (window as any).dataLayer.push(data);
}

export const dataLayer = {
    push
};
